import React, { Fragment, useState, useEffect, useRef } from "react";
import { Redirect, useNavigation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import loading from "../components/loading.json";
import { themeStyle, themeStyleDark } from "../components/Components";
import Backdrop from "@mui/material/Backdrop";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Grid } from "@mui/material";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import VisitUs from "../components/VisitUs";
import CountUp from "react-countup";
import axios from "axios";
import { API_URL } from "../actions/auth";
import {
  useSpringCarousel,
  useTransitionCarousel,
} from "react-spring-carousel";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import { useInView, useSpring, animated, useScroll } from "@react-spring/web";
import background from "../img/1.jpg";

function getBlogImageUrl(blog) {
  if (!blog?.image_url) {
    return background;
  }
  if (blog.image_url.startsWith("http")) {
    return blog.image_url;
  }
  return API_URL + blog.image_url.replace(/^\//, "");
}

export default function Blog() {
  const state = useSelector((state) => state);
  const [news, setNews] = useState([
    { image: "", title: "", subtitle: "" },
    { image: "", title: "", subtitle: "" },
    { image: "", title: "", subtitle: "" },
    { image: "", title: "", subtitle: "" },
  ]);
  const dispatch = useDispatch();

  const [zoom1, zoom1api] = useSpring(() => ({
    from: { transform: "scale(1)" },
  }));

  const [zoom2, zoom2api] = useSpring(() => ({
    from: { transform: "scale(1)" },
  }));
  const [isLoading, setIsLoading] = useState(false);
  const [blogs, setBlogs] = useState({ Latest: [{ title: "Loading" }] });
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(API_URL + "get_all_blog_posts")
      .then((res) => {
        if (res.data["Latest"].length != 0) {
          setBlogs(res.data);
        }
        setIsLoading(false);
      })
      .catch((err) => {});
  }, []);

  const { carouselFragment, slideToPrevItem, slideToNextItem } =
    useSpringCarousel({
      withLoop: true,
      items: blogs["Latest"].map((blog, index) => {
        return {
          id: "item-" + index.toString(),
          renderItem: (
            <Link
              to={"/blog/" + blog.slug + "/"}
              params={{ slug: blog.slug }}
              style={{
                width: "100%",
                cursor: "pointer",
                textDecoration: "none",
                margin: "15px",
              }}
            >
              <div
                style={{
                  cursor: "pointer",
                  height: "100%",
                  width: "100%",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundImage:
                    "linear-gradient(0deg, rgba(0,0,0,0.9), rgba(0, 0, 0, 0.5), rgba(2, 77, 194, 0.0)), url('" +
                    getBlogImageUrl(blog) +
                    "')",
                  borderRadius: 10,
                  textAlign: "left",
                  textAlign: "left",
                  padding: "2.2vh",
                }}
              >
                <div
                  style={{
                    fontSize: "3.6vh",
                    position: "absolute",
                    left: 40,
                    bottom: 40,
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  {blog.title}
                </div>
              </div>
            </Link>
          ),
        };
      }),
    });

  useEffect(() => {
    const timer = setInterval(() => {
      slideToNextItem();
    }, 4000);
    return () => {
      window.clearInterval(timer);
    };
  }, [slideToNextItem]);

  function getContent() {
    return (
      <div className="main">
        <Sidebar />

        <div className="anigrad" style={{ height: "100vh" }}>
          <div
            style={{
              height: "90vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100vw",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "75vw",
                marginLeft: state.auth.isMobile ? "0px" : "0px",
              }}
            >
              <div
                style={{
                  fontSize: state.auth.isMobile ? "70px" : "100px",
                  color: "yellow",
                  zIndex: 999,
                  textAlign: state.auth.isMobile ? "center" : "left",
                  marginTop: "150px",
                }}
              >
                <h1>Blog</h1>
              </div>

              <div
                style={{
                  borderBottom: "2px solid white",
                  width: "100%",
                  margin: "15px 0px 15px 0px",
                }}
              ></div>
              <div
                style={{
                  fontSize: state.auth.isMobile ? "30px" : "4.4vh",
                  color: "white",
                  zIndex: 999,
                }}
              >
                News and insights on all things by Riches Media Digital.
              </div>
            </div>
            <div
              style={{
                display: state.auth.isMobile ? "none" : "block",
                marginLeft: "500px",
                width: "40%",
                height: "50%",
                marginTop: "50px",
              }}
            >
              {carouselFragment}
            </div>
            <animated.div
              onClick={() => {
                slideToNextItem();
              }}
              onMouseEnter={() => {
                zoom1api.start({
                  from: {
                    transform: "scale(1)",
                  },
                  to: {
                    transform: "scale(1.1)",
                  },
                });
              }}
              onMouseLeave={() => {
                zoom1api.start({
                  from: {
                    transform: "scale(1.1)",
                  },
                  to: {
                    transform: "scale(1)",
                  },
                });
              }}
              style={{
                display: state.auth.isMobile ? "none" : "flex",
                position: "absolute",
                width: "10vh",
                height: "10vh",
                border: "2px solid white",
                borderRadius: "100px",
                top: "15vh",
                right: 75,
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                ...zoom1,
              }}
            >
              <ArrowRightIcon style={{ fontSize: "8.75vh", color: "white" }} />
            </animated.div>
            <animated.div
              onClick={() => {
                slideToPrevItem();
              }}
              onMouseEnter={() => {
                zoom2api.start({
                  from: {
                    transform: "scale(1)",
                  },
                  to: {
                    transform: "scale(1.1)",
                  },
                });
              }}
              onMouseLeave={() => {
                zoom2api.start({
                  from: {
                    transform: "scale(1.1)",
                  },
                  to: {
                    transform: "scale(1)",
                  },
                });
              }}
              style={{
                display: state.auth.isMobile ? "none" : "flex",
                position: "absolute",
                width: "10vh",
                height: "10vh",
                border: "2px solid white",
                borderRadius: "100px",
                top: "27vh",
                right: 75,
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                ...zoom2,
              }}
            >
              <ArrowLeftIcon style={{ fontSize: "8.75vh", color: "white" }} />
            </animated.div>
          </div>
        </div>
        <div
          style={{
            padding: state.auth.isMobile ? "10px" : "10vh",
            marginLeft: state.auth.isMobile ? "-2.2vh" : "0px",
          }}
        >
          {Object.keys(blogs).map((category, index) => (
            <div
              style={{
                fontSize: "8.75vh",
                color: "white",
                zIndex: 999,
                textAlign: "left",
                fontWeight: "bold",
                marginBottom: "100px",
              }}
            >
              <div style={{ marginLeft: "2.2vh" }}>{category}</div>
              <Grid container>
                {blogs[category].map((blog, index) => (
                  <Grid
                    item
                    xs={12}
                    md={4}
                    style={{
                      cursor: "pointer",
                      marginTop: "10px",
                      marginLeft: state.auth.isMobile ? "-15px" : "0px",
                      padding: "10px 10px 0px 10px",
                      width: "100%",
                      height: state.auth.isMobile ? "26vh" : "32vh",
                      zIndex: 100,
                      textAlign: "left",
                      marginBottom: "100px",
                    }}
                  >
                    <Link
                      to={"/blog/" + blog.slug + "/"}
                      params={{ slug: blog.slug }}
                      style={{
                        width: "100%",
                        cursor: "pointer",
                        textDecoration: "none",
                      }}
                    >
                      <div
                        style={{
                          height: "100%",
                          width: "100%",
                          margin: "15px",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundImage:
                            "url('" + getBlogImageUrl(blog) + "')",
                          borderRadius: 10,
                        }}
                      ></div>
                      <div
                        style={{
                          fontSize: "3.6vh",
                          marginLeft: "15px",
                          color: "black",
                          fontWeight: "bold",
                        }}
                      ></div>
                      <div
                        style={{
                          fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
                          marginLeft: "15px",
                          color: "white",
                        }}
                      >
                        {blog.title}
                      </div>
                    </Link>
                  </Grid>
                ))}
              </Grid>
            </div>
          ))}
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
